import { notify } from 'client/util';
import Constants, {
  ItemTypeConsts,
  StoreModuleMap,
} from 'client/util/Constants';
import store from 'client/store';

const settingsModule = StoreModuleMap[ItemTypeConsts.settings];
const { error } = Constants;

export class RbacUtil {
  constructor(theStore = store) {
    this.notifySubstitute = null;
    this.errorMessage = 'You don\'t have permission to make this change. If you think this is an error, contact your admin.';
    this.urlCommandRegex = /https?:\/\/.*?v+\d\/command/gmi;
    this.useNotify = true;
    this.store = theStore;
  }

  getForbiddenMessage() {
    return this.errorMessage;
  }

  /**
   * RbacUtil uses notify to show 403 error message,
   * but some parts of the admin portal uses other notification system.
   * This function cancels notify call and instead setups a callback to
   * be called when the response is a 403
   * @param {Function} cb
   */
  dontUseNotifyUtil(cb) {
    this.useNotify = false;
    this.notifySubstitute = () => {
      cb();
      this.useNotify = true;
    };
  }

  testForCommandRunner(request) {
    const isCommandRunner = this.store.getters[`${settingsModule}/isCommandRunner`] || false;
    const isCommandRunnerUrl = this.urlCommandRegex.test(request.responseURL);
    return isCommandRunner && !isCommandRunnerUrl;
  }

  pollBulkActionIsFinish() {
    const isBulkTaskInProgress = this.store.getters['ProgressModule/isBulkTaskInProgress'];

    if (isBulkTaskInProgress) {
      const remainingTasks = this.store.getters['ProgressModule/getRemainingCount'];
      return remainingTasks === 1;
    }

    return true;
  }

  handleForbidden403(status = 403) {
    if (status === 403) {
      if (this.useNotify) {
        return notify(error, this.errorMessage);
      }

      return this.notifySubstitute();
    }

    this.notifySubstitute = null;
    return undefined;
  }
}

const rbacUtil = new RbacUtil();

export default rbacUtil;
